import { render, staticRenderFns } from "./BettingResult.vue?vue&type=template&id=81dc9294&scoped=true"
import script from "./BettingResult.vue?vue&type=script&lang=js"
export * from "./BettingResult.vue?vue&type=script&lang=js"
import style0 from "./BettingResult.vue?vue&type=style&index=0&id=81dc9294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81dc9294",
  null
  
)

export default component.exports